export default __webpack_public_path__ + "static/compound-0ba22f003bde09f768b085a7d6bf9c87.png";